if (!customElements.get('collapsible-text')) {
  customElements.define('collapsible-text', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-collapsible-content]');
      this.toggle = this.querySelector('[data-collapsible-toggle]');
      if (!this.content || !this.toggle) return;

      const threshold = Number(this.dataset.threshold) || 240;
      const hasOverflow = this.content.scrollHeight > this.content.clientHeight + 1;
      if (this.content.textContent.trim().length <= threshold || !hasOverflow) {
        this.toggle.hidden = true;
        return;
      }

      this.collapsedHeight = this.content.getBoundingClientRect().height;
      this.toggle.addEventListener('click', this.onToggle.bind(this));
      this.classList.add('is-collapsible');
    }

    onToggle() {
      const expanded = !this.classList.contains('is-expanded');
      this.content.style.maxHeight = `${this.content.getBoundingClientRect().height}px`;
      this.content.offsetHeight;
      this.classList.toggle('is-expanded', expanded);
      this.content.style.maxHeight = `${expanded ? this.content.scrollHeight : this.collapsedHeight}px`;
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggle.textContent = expanded ? this.dataset.readLess : this.dataset.readMore;
    }
  });
}
